import React, { useEffect, useRef, useState } from "react";
import DailyIframe from "@daily-co/daily-js";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";

const VideoConsultation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const callFrame = useRef(null);
  const roomId = new URLSearchParams(location.search).get("room") || location.state?.roomId;

  useEffect(() => {
    if (!roomId) {
      setError("This consultation link is missing a room ID. Open it from your appointment.");
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    const joinRoom = async () => {
      try {
        const response = await api.post("/api/daily-room/create-or-get", { roomId });
        const roomUrl = response?.data?.roomUrl;
        if (!roomUrl) throw new Error("The consultation room is unavailable.");
        if (cancelled) return;

        callFrame.current = DailyIframe.createFrame({
          showLeaveButton: true,
          iframeStyle: { position: "fixed", inset: 0, width: "100%", height: "100%", border: "none" },
        });
        await callFrame.current.join({ url: roomUrl });
        setLoading(false);
      } catch (joinError) {
        if (!cancelled) {
          setError(joinError?.response?.data?.error || joinError.message || "Unable to join this consultation.");
          setLoading(false);
        }
      }
    };

    joinRoom();
    return () => {
      cancelled = true;
      callFrame.current?.destroy();
      callFrame.current = null;
    };
  }, [roomId]);

  if (loading) return <p className="text-center mt-4">Joining your consultation…</p>;
  if (error) return <div className="text-center mt-4"><p className="text-danger">{error}</p><button className="btn btn-primary" onClick={() => navigate("/appoint")}>Back to appointments</button></div>;

  return null; // The video iframe is injected automatically
};

export default VideoConsultation;
